import "./layout.scss";
import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../header/header";
import SideBar from "../sidebar/sideBar";
import { getSessionToken } from "../../utils/api";

function Layout(props) {
  const [showSideBar, setShowSideBar] = useState(() => window.innerWidth > 1296);
  let navigate = useNavigate();
  // useCallback causes unnecessary re-renders, but here it's needed to avoid adding handleResize to useEffect dependencies
  const handleResize = useCallback(() => {
    setShowSideBar(window.innerWidth >= 1296);
  }, []);

  useEffect(() => {
    if (getSessionToken() === undefined) {
      navigate("/");
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [navigate, handleResize]);
  
  const toggleSideBar = () => {
    setShowSideBar(!showSideBar);
  }
  const hideMobileMenu = () => {
    if(showSideBar && window.innerWidth < 1296) {
        setShowSideBar(false)
      }
  }

  return (
    <div className="layout" onClick={hideMobileMenu}>
      <SideBar showSideBar={showSideBar} />
      <div className="leftSide">
        <Header toggleSideBar={toggleSideBar} />
        <div className="pageContent">{props.children}</div>
      </div>
    </div>
  );
}
export default Layout;
